import { DocumentReference, Timestamp } from 'firebase/firestore';

/**
 * Status options for repair items
 */
export enum RepairStatus {
  Pending = 'Beklemede',
  InProgress = 'İşlemde',
  Done = 'Tamamlandı',
  PickedUp = 'Teslim Edildi'
}

/**
 * Payment status options for repair items
 */
export enum PaymentStatus {
  Unpaid = 'Ödenmedi',
  PartiallyPaid = 'Kısmen Ödendi',
  FullyPaid = 'Tamamen Ödendi'
}

/**
 * Repair item information
 */
export interface Repair {
  customerId: DocumentReference;
  itemType: string;
  description: string;
  priceEstimate?: number;
  finalPrice?: number;
  status: RepairStatus;
  paymentStatus: PaymentStatus;
  paidAmount: number;
  remainingBalance?: number;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  pickedUp: boolean;
  pickupTimestamp?: Timestamp;
}

/**
 * Repair with ID field
 */
export interface RepairWithId extends Repair {
  id: string;
} 